import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import { sendContactEmail } from '../../helper/sendMail';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';

const initialForm = { firstName: '', lastName: '', email: '', mobile: '', message: '' };

export default function ContactPage() {
  pageTitle('Contact Us');

  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMsg('');
    try {
      await sendContactEmail(form);
      setStatus('success');
      setForm(initialForm);
    } catch {
      setStatus('error');
      setErrorMsg('Something went wrong. Please try again or email us at info@dreamscript.io');
    }
  };

  return (
    <>
      <PageHeading
        title="Contact Us"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading title="Get in Touch?" subtitle="" />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            {status === 'success' ? (
              <Div className="cs-contact_success">
                <h3 className="cs-font_26 cs-m0">Message sent!</h3>
                <Spacing lg="15" md="15" />
                <p className="cs-m0">Thank you for reaching out. We will be in touch shortly.</p>
              </Div>
            ) : (
              <form onSubmit={handleSubmit} className="row">
                <Div className="col-sm-6">
                  <label className="cs-primary_color">First Name*</label>
                  <input
                    type="text"
                    name="firstName"
                    value={form.firstName}
                    onChange={handleChange}
                    className="cs-form_field"
                    required
                  />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Last Name*</label>
                  <input
                    type="text"
                    name="lastName"
                    value={form.lastName}
                    onChange={handleChange}
                    className="cs-form_field"
                    required
                  />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Email*</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className="cs-form_field"
                    required
                  />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-6">
                  <label className="cs-primary_color">Mobile*</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={form.mobile}
                    onChange={handleChange}
                    className="cs-form_field"
                    required
                  />
                  <Spacing lg="20" md="20" />
                </Div>
                <Div className="col-sm-12">
                  <label className="cs-primary_color">Message*</label>
                  <textarea
                    name="message"
                    cols="30"
                    rows="7"
                    value={form.message}
                    onChange={handleChange}
                    className="cs-form_field"
                    required
                  />
                  <Spacing lg="25" md="25" />
                </Div>
                {status === 'error' && (
                  <Div className="col-sm-12">
                    <p className="cs-error_text">{errorMsg}</p>
                    <Spacing lg="15" md="15" />
                  </Div>
                )}
                <Div className="col-sm-12">
                  <button
                    type="submit"
                    className="cs-btn cs-style1"
                    disabled={status === 'sending'}
                  >
                    <span>{status === 'sending' ? 'Sending…' : 'Send Message'}</span>
                    {status !== 'sending' && <Icon icon="bi:arrow-right" />}
                  </button>
                </Div>
              </form>
            )}
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Spacing lg="50" md="40" />
    </>
  );
}
